import { render, staticRenderFns } from "./ValidationDecimal.vue?vue&type=template&id=cb1b6f2a&"
import script from "./ValidationDecimal.vue?vue&type=script&lang=js&"
export * from "./ValidationDecimal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports